import {BaseForm} from '@management-ui/core';
import * as React from 'react';
import {forwardRef, useContext, useImperativeHandle, useRef} from 'react';
import {ServiceContext} from '../../../../components/Services';
import Fields from './Fields';

const VehicleTypeForm = forwardRef(({type, onSaved}, ref) => {
  const services = useContext(ServiceContext);
  /** @type {({current: BaseForm})} */
  const formRef = useRef(null);

  useImperativeHandle(ref, () => ({
    save() {
      formRef.current.save();
    }
  }));

  return (
    <BaseForm
      ref={formRef}
      entity={type}
      type="type"
      fieldsComponent={Fields}
      onSave={(update) => services.vehicleType.saveType(update)}
      onSaved={onSaved}
    />
  );
});

export default VehicleTypeForm;
